<template>
    <div class="tco-tool__container">
        <div class="tco-tool__filters">
            <div class="tco-tool__drop-down">
                <label class="tco-tool__label" :for="formBrandID">Please select your brand:</label>
                <button class="tco-tool__fake-select" :class="{'tco-tool__fake-select--selected': showBrandSelector}" @click="toggleShowBrand">
                    <div v-if="brand == null">Please select a brand</div>
                    <div v-else>{{ brand.manufacturer }}</div>
                    <img src="/images/tco/down-arrow.svg" alt="Down arrow" class="tco-tool__down-arrow" />
                </button>
            </div>
            <div class="tco-tool__drop-down">
                <label class="tco-tool__label" :for="formBrandID">Please select an electric vehicle:</label>
                <button class="tco-tool__fake-select" :class="{'tco-tool__fake-select--selected': showEvSelector, 'tco-tool__fake-select--disabled': !brand}" @click="toggleShowEv">
                    <div v-if="brand == null">Please select a brand first</div>
                    <div v-else-if="selectedEvVehicle == null">Please select a model</div>
                    <div v-else>{{ selectedEvVehicleTitle }}</div>
                    <img src="/images/tco/down-arrow.svg" alt="Down arrow" class="tco-tool__down-arrow" />
                </button>
            </div>
            <div class="tco-tool__drop-down">
                <label class="tco-tool__label" :for="formBrandID">Compare to:</label>
                <button class="tco-tool__fake-select" :class="{'tco-tool__fake-select--selected': showIceSelector, 'tco-tool__fake-select--disabled': !brand}" @click="toggleShowIce">
                    <div v-if="brand == null">Please select a brand first</div>
                    <div v-else-if="selectedIceVehicle == null">Please select a model</div>
                    <div v-else>{{ selectedIceModel.short_name }}</div>
                    <img src="/images/tco/down-arrow.svg" alt="Down arrow" class="tco-tool__down-arrow" />
                </button>
            </div>
            <!-- <div class="tco-tool__drop-down">
                <label class="tco-tool__label" :for="formBrandID">Monthly spend on clean air zones?</label>
                <CurrencyInput class="tco-tool__currency-input" v-model="cleanAirZoneCost" :show-label="false" input-name="clean_air_zone_cost" input-title="Monthly spend on clean air zones?" :inputValidate="false" inputValidateMessage="Monthly spend on clean air zones?"></CurrencyInput>
            </div> -->

            <div class="tco-tool__slider-container tco-tool__slider tco-tool__slider--term" v-show="bothVehiclesSelected != false">
                <div class="tco-tool__slider-label-container">
                    <div class="tco-tool__slider-label">Set your term (months):</div>
                    <div class="tco-tool__slider-value">{{ term }} months</div>
                </div>
                <div ref="term-slider"></div>
            </div>

            <div class="tco-tool__slider-container tco-tool__slider tco-tool__slider--deposit" v-show="bothVehiclesSelected != false">
                <div class="tco-tool__slider-label-container">
                    <div class="tco-tool__slider-label">Set your deposit:</div>
                    <div class="tco-tool__slider-value">{{ formattedDeposit }}</div>
                </div>
                <div ref="deposit-slider"></div>
            </div>

            <div class="tco-tool__slider-container tco-tool__slider tco-tool__slider--mileage" v-show="bothVehiclesSelected != false">
                <div class="tco-tool__slider-label-container">
                    <div class="tco-tool__slider-label">Set your annual mileage (miles):</div>
                    <div class="tco-tool__slider-value">{{ formattedMileage }} miles</div>
                </div>
                <div ref="mileage-slider"></div>
            </div>

            <!-- <button @click="showComparison" class="btn btn--primary tco-tool__btn-calculate">Calculate</button>
            <button @click="reset" class="btn btn--blue-inverted tco-tool__btn-reset">Reset</button> -->

            <div ref="scrollableBrands" class="tco-tool__popout tco-tool__popout--scrollable rd-card" v-show="showBrandSelector">
                <div class="tco-tool__popout-top">
                    <button type="button" class="btn btn--fake-link link link--secondary link--has-icon-reverse hidden__sm hidden__md hidden_lg" @click="showBrandSelector = false">Back</button>
                </div>
                <div class="choose-brand__box tco-tool__choose-brand-box">
                    <h3 class="choose-brand__h3">
                        Please select a brand
                    </h3>
                    <ul :class="{'tco-tool__brand-logo-border': true, 'choose-brand__grid': true, ['choose-brand__grid--' + brandCount + '-brands']: true, 'ul__no-bullet': true}">
                        <li class="choose-brand__logo tco-tool__brand-logo-outer" :class="{'tco-tool__brand-logo-outer--selected': (brand && brand.brand == possibleBrand.brand)}" v-for="possibleBrand in brands" :key="possibleBrand.brand" @click="selectBrand(possibleBrand)">
                            <div class="tco-tool__brand-logo">
                                <picture v-if="possibleBrand.brand == 'abarth'">
                                    <source type="image/webp" srcset="/img/logos/borderless/abarth.webp, /img/logos/borderless/abarth@2x.webp 2x">
                                    <img class="img-responsive choose-brand__image" srcset="/img/logos/borderless/abarth.png, /img/logos/borderless/abarth@2x.png 2x" alt="Abarth">
                                </picture>
                                <img v-else :key="possibleBrand.brand + '2'" class="img-responsive choose-brand__image" :src="brandLogoPath('/img/logos/borderless/' + possibleBrand.brand + '.svg', true)" :alt="possibleBrand.manufacturer">
                            </div>
                            <!-- <button @click="selectBrand(possibleBrand)" class="tco-tool__choose-brand-btn btn btn--fake-link">Select brand</button> -->
                        </li>
                    </ul>
                </div>
            </div>

            <div ref="scrollableEvs" class="tco-tool__popout rd-card" v-if="showEvSelector">
                <PopoutModelSelector :is-electric="true" :brand="brand" v-on:close-selector="showEvSelector = false;showIceSelector = true"></PopoutModelSelector>
            </div>

            <div ref="scrollableIces" class="tco-tool__popout rd-card" v-if="showIceSelector">
                <PopoutModelSelector :is-electric="false" :brand="brand" v-on:close-selector="handleIceVehicleSelected"></PopoutModelSelector>
            </div>
        </div>

        <div ref="comparison" class="tco-tool__comparison">
            <ComparisonCard :enquire-now-link="enquireNowLink" :term="term" :deposit="deposit" :mileage="mileage" :brand="brand" :is-electric="true" v-on:match-height="matchBoxHeights" v-on:match-height-fuel="matchFuelBoxHeights"></ComparisonCard>
            <ComparisonCard :enquire-now-link="enquireNowLink" :term="term" :deposit="deposit" :mileage="mileage" :brand="brand" :is-electric="false" v-on:match-height="matchBoxHeights" v-on:match-height-fuel="matchFuelBoxHeights"></ComparisonCard>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import noUiSlider from "nouislider";
import NumberFormat from "../../../used-vue/api/NumberFormat";
import { mapMutations, mapState, mapActions } from "vuex";
import CurrencyInput from "../../../used-vue/components/Forms/redesign/CurrencyInput.vue";
import PopoutModelSelector from "./Components/PopoutModelSelector.vue";
import ComparisonCard from "./Components/ComparisonCard.vue";
import { MatchHeight } from "js-match-height";
import { customEvent } from '../../../modules/tracking/AnalyticsEvents';
import brandLogoPath from '../../../modules/brandLogoPath';

const bodyScrollLock = require('body-scroll-lock');

export default {
    props: {
        enquireNowLink: {
            required: false,
            default: null,
        },
    },
    components: {
        CurrencyInput,
        // PopoutGridModels,
        // PopoutGridModel,
        // PopoutGridTrims,
        PopoutModelSelector,
        ComparisonCard
    },
    data() {
        return {
            showBrandSelector: false,
            brand: null,

            showEvSelector: false,
            evModel: null,
            evVehicleID: null,

            showIceSelector: false,
            iceVehicleID: null,

            // cleanAirZoneCost: null,

            termSlider: null,
            term: 48,
            terms: [36,48],

            depositSlider: null,
            minDeposit: 0,
            maxDeposit: 80000,
            deposit: 1200,

            mileageSlider: null,
            mileage: 10000,
            mileages: [8000, 10000, 12000],

            matchHeightInstances: [],
        };
    },
    watch: {
        bothVehiclesSelected: function(newValue) {
            Promise.all([
                this.getAvailableParameters(this.selectedIceVehicle),
                this.getAvailableParameters(this.selectedEvVehicle),
            ])
            .then(data => {
                const pcpDefaults = [];
                data.forEach(defaults => {
                    if (typeof defaults.Products == 'undefined') {
                        return;
                    }
                    defaults.Products.forEach(product => {
                        if (typeof product.Key == 'undefined' || product.Key.toLowerCase() != 'pcp') {
                            return;
                        }
                        if (typeof product.HasError != 'undefined' && product.HasError == true) {
                            return;
                        }
                        if (typeof product.Term == 'undefined') {
                            return;
                        }
                        if (typeof product.Deposit == 'undefined') {
                            return;
                        }
                        if (typeof product.AnnualMileage == 'undefined') {
                            return;
                        }
                        pcpDefaults.push(product);
                    });
                });
                let minDeposit = null;
                let maxDeposit = null;
                let terms = [];
                let mileages = [];
                pcpDefaults.forEach(product => {
                    if (typeof product.Deposit.Minimum != 'undefined') {
                        let deposit = parseFloat(product.Deposit.Minimum);
                        if (minDeposit === null || deposit > minDeposit) {
                            minDeposit = deposit;
                        }
                    }
                    if (typeof product.Deposit.Maximum != 'undefined') {
                        let deposit = parseFloat(product.Deposit.Maximum);
                        if (maxDeposit === null || deposit < maxDeposit) {
                            maxDeposit = deposit;
                        }
                    }
                    if (typeof product.Term != 'undefined' && typeof product.Term.Values != 'undefined') {
                        if (terms === null) {
                            terms = product.Term.Values;
                        } else {
                            product.Term.Values.forEach(term => {
                                if (terms.indexOf(term) >= 0) {
                                    return;
                                }
                                terms.push(term);
                            })
                        }
                    }
                    if (typeof product.AnnualMileage != 'undefined' && typeof product.AnnualMileage.Values != 'undefined') {
                        if (mileages === null) {
                            mileages = product.AnnualMileage.Values;
                        } else {
                            product.AnnualMileage.Values.forEach(mileage => {
                                let mileageAsInt = parseInt(mileage);
                                if (mileages.indexOf(mileageAsInt) >= 0) {
                                    return;
                                }
                                mileages.push(mileageAsInt);
                            })
                        }
                    }
                });
                terms.sort(function(a, b) {
                    return a - b;
                });
                this.terms = terms;
                this.term = this.closest(this.term, this.terms);
                mileages.sort(function(a, b) {
                    return a - b;
                });
                this.mileages = mileages;
                this.mileage = this.closest(this.mileage, this.mileages);
                if (minDeposit === null) {
                    this.minDeposit = 0;
                } else {
                    this.minDeposit = minDeposit;
                }
                if (maxDeposit === null) {
                    this.maxDeposit = 20000;
                } else {
                    this.maxDeposit = maxDeposit;
                }
                if (this.deposit > this.maxDeposit) {
                    this.deposit = this.maxDeposit;
                }
                if (this.deposit < this.minDeposit) {
                    this.deposit = this.minDeposit;
                }
                this.setupSliders();
            })
            .catch(error => {
                console.error(error);
            });
        },
        showBrandSelector: function(newValue) {
            const liveChatCard = document.querySelector('.live-chat-card__outer');
            if (newValue !== true) {
                document.querySelector('.header-menu__headroom').classList.remove('hidden__xs');
                if (liveChatCard) {
                    liveChatCard.style.display = null;
                }
                if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                    bodyScrollLock.enableBodyScroll(this.$refs['scrollableBrands']);
                }
                return;
            }

            document.querySelector('.header-menu__headroom').classList.add('hidden__xs');
            if (liveChatCard) {
                liveChatCard.style.display = 'none';
            }
            if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                bodyScrollLock.disableBodyScroll(this.$refs['scrollableBrands']);
            }
        },
        showEvSelector: function(newValue) {
            const liveChatCard = document.querySelector('.live-chat-card__outer');
            if (newValue !== true) {
                document.querySelector('.header-menu__headroom').classList.remove('hidden__xs');
                if (liveChatCard) {
                    liveChatCard.style.display = null;
                }
                if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                    bodyScrollLock.enableBodyScroll(this.$refs['scrollableEvs']);
                }
                return;
            }

            document.querySelector('.header-menu__headroom').classList.add('hidden__xs');
            if (liveChatCard) {
                liveChatCard.style.display = 'none';
            }
            if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                bodyScrollLock.disableBodyScroll(this.$refs['scrollableEvs']);
            }
        },
        showIceSelector: function(newValue) {
            const liveChatCard = document.querySelector('.live-chat-card__outer');
            if (newValue !== true) {
                document.querySelector('.header-menu__headroom').classList.remove('hidden__xs');
                if (liveChatCard) {
                    liveChatCard.style.display = null;
                }
                if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                    bodyScrollLock.enableBodyScroll(this.$refs['scrollableIces']);
                }
                return;
            }

            document.querySelector('.header-menu__headroom').classList.add('hidden__xs');
            if (liveChatCard) {
                liveChatCard.style.display = 'none';
            }
            if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                bodyScrollLock.disableBodyScroll(this.$refs['scrollableIces']);
            }
        },
    },
    methods: {
        brandLogoPath,
        ...mapMutations([
            'setSelectedEvModel',
            'setSelectedIceModel',
            'setSelectedEvTrim',
            'setSelectedIceTrim',
            'setSelectedEvVehicle',
            'setSelectedIceVehicle',
        ]),
        ...mapActions(['getBrands','getVehicles']),
        closest(numberToMatch, arrayToSearch) {
            let closest = null,
                closestDiff = null;
            const length = arrayToSearch.length;
            for (let index = 0; index < length; index++) {
                const currentIndexValue = arrayToSearch[index];
                if (currentIndexValue == numberToMatch) {
                    return currentIndexValue;
                }
                const diff = Math.abs(numberToMatch - currentIndexValue);
                if (closestDiff == null || diff < closestDiff) {
                    closestDiff = diff;
                    closest = currentIndexValue;
                }
            }
            return closest;
        },
        setupSliders() {
            const minTerm = this.terms[0];
            const termsLength = this.terms.length;
            const maxTerm = this.terms[termsLength - 1];
            const termDiff = maxTerm - minTerm;
            const termsRange = {};
            if (termsLength > 1) {
                this.terms.forEach((term, index) => {
                    if (index == 0) {
                        termsRange['min'] = [term];
                        return;
                    }
                    if (index == termsLength - 1) {
                        termsRange['max'] = [term];
                        return;
                    }
                    const percent = Math.round((100 / termDiff) * (term - minTerm));
                    termsRange[percent + '%'] = [term];
                });
            } else {
                termsRange['min'] = [this.terms[0]];
                termsRange['max'] = [this.terms[0]];
            }

            if (!this.termSlider) {
                this.termSlider = noUiSlider.create(this.$refs['term-slider'], {
                    start: [this.term],
                    connect: 'lower',
                    range: termsRange,
                    snap: true,
                });
                this.termSlider.on('update', values => {
                    this.term = parseInt(values[0]);
                });
            } else {
                this.termSlider.updateOptions({
                    range: termsRange
                });
            }

            if (!this.depositSlider) {
                this.depositSlider = noUiSlider.create(this.$refs['deposit-slider'], {
                    start: [this.deposit],
                    connect: 'lower',
                    range: {
                        min: this.minDeposit,
                        max: this.maxDeposit
                    },
                    step: 100,
                });
                this.depositSlider.on('update', values => {
                    this.deposit = parseInt(values[0]);
                });
            } else {
                this.depositSlider.updateOptions({
                    range: {
                        min: this.minDeposit,
                        max: this.maxDeposit,
                    }},
                );
            }

            const minMileage = this.mileages[0];
            const mileagesLength = this.mileages.length;
            const maxMileage = this.mileages[mileagesLength - 1];
            const mileageDiff = maxMileage - minMileage;
            const mileageRange = {};
            this.mileages.forEach((mileage, index) => {
                if (index == 0) {
                    mileageRange['min'] = [mileage];
                    return;
                }
                if (index == mileagesLength - 1) {
                    mileageRange['max'] = [mileage];
                    return;
                }
                const percent = Math.round((100 / mileageDiff) * (mileage - minMileage));
                mileageRange[percent + '%'] = [mileage];
            });

            if (!this.mileageSlider) {
                this.mileageSlider = noUiSlider.create(this.$refs['mileage-slider'], {
                    start: [this.mileage],
                    connect: 'lower',
                    range: mileageRange,
                    snap: true,
                });
                this.mileageSlider.on('update', values => {
                    this.mileage = parseInt(values[0]);
                })
            } else {
                this.mileageSlider.updateOptions({
                    range: mileageRange
                });
            }
        },
        toggleShowBrand() {
            this.showBrandSelector = !this.showBrandSelector;
            if (this.showBrandSelector) {
                this.showEvSelector = false;
                this.showIceSelector = false;
            }
        },
        toggleShowEv() {
            if (!this.brand) {
                return;
            }
            this.showEvSelector = !this.showEvSelector;
            if (this.showEvSelector) {
                this.showBrandSelector = false;
                this.showIceSelector = false;
            }
        },
        toggleShowIce() {
            if (!this.brand) {
                return;
            }
            this.showIceSelector = !this.showIceSelector;
            if (this.showIceSelector) {
                this.showEvSelector = false;
                this.showBrandSelector = false;
            }
        },
        selectBrand(brandToSelect) {
            if (!brandToSelect || brandToSelect.brand != this.brand) {
                this.setSelectedEvModel(null);
                this.setSelectedIceModel(null);
                this.setSelectedEvTrim(null);
                this.setSelectedIceTrim(null);
                this.setSelectedEvVehicle(null);
                this.setSelectedIceVehicle(null);
                this.getVehicles(brandToSelect.brand);
                this.showEvSelector = true;
            }
            this.brand = brandToSelect;
            this.showBrandSelector = false;
            customEvent('TCO', 'Clicked', 'Step 1 - ' + this.brand.brand + ' Logo');
        },
        showComparison() {
            if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                const target = this.$refs['comparison'];
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        },
        reset() {
            this.brand = null;
            this.setSelectedEvModel(null);
            this.setSelectedIceModel(null);
            this.setSelectedEvTrim(null);
            this.setSelectedIceTrim(null);
            this.setSelectedEvVehicle(null);
            this.setSelectedIceVehicle(null);
        },
        getAvailableParameters(vehicle) {
            return new Promise((resolve, reject) => {
                // Try to collect available params from session storage cache
                const cachedFinanceParams = sessionStorage.getItem('new.finance.params.' + vehicle.id);

                // if (cachedFinanceParams !== null) {
                //     try {
                //         // If we're able to parse what's stored, resolve the promise with it
                //         resolve(JSON.parse(cachedFinanceParams));
                //         return;
                //     } catch (error) {
                //         console.error(error);
                //     }
                // }

                const buildToOrderVehicleData = {
                    "OnTheRoadPrice": vehicle.pricing_display_price,
                    "IsNew": true,
                    "Identifier": (vehicle.titre_code) ? vehicle.titre_code : vehicle.cap_id,
                    "IdentifierType": 'Titre',
                    "Type": (vehicle.type == 'car') ? 'Car' : 'Lcv',
                };

                if (!vehicle.titre_code) {
                    if (buildToOrderVehicleData.Type == 'Car') {
                        buildToOrderVehicleData.IdentifierType = 'CapCarShortCode';
                    } else {
                        buildToOrderVehicleData.IdentifierType = 'CapLcvShortCode';
                    }
                }

                // If we got this far, then we were unable to get finance params from cache
                // Build the JSON request data for this vehicle
                axios.post('https://services.codeweavers.net/api/finance/defaults', {
                    Credentials: {
                        ApiKey: "ONH75GHd8x0gu6yfJ6",
                    },
                    BuildToOrderVehicle: buildToOrderVehicleData,
                })
                    .then(response => {
                        if (typeof response.data.Error != 'undefined' && response.data.Error == true) {
                            sessionStorage.setItem('new.finance.params.' + vehicle.id, JSON.stringify({}));
                            reject();
                            return;
                        }
                        sessionStorage.setItem('new.finance.params.' + vehicle.id, JSON.stringify(response.data));

                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error(error);
                        reject(error);
                    })
            });
        },
        getMatchHeightInstance(index) {
            if (typeof this.matchHeightInstances[index] == 'undefined') {
                this.matchHeightInstances[index] = new MatchHeight(".tco-tool__comparison-card-item--" + index, {
                    debounce: 100,
                    timeout: 100
                });
            }
            return this.matchHeightInstances[index];
        },
        matchHeightForQuerySelector(selector) {
            const elements = document.querySelectorAll(selector);
            const elementLength = elements.length;
            if (elementLength == 0) {
                return;
            }
            for (let index = 0; index < elementLength; index++) {
                const element = elements[index];
                element.style.height = null;
            }
            if (elementLength == 1) {
                return;
            }
            setTimeout(function() {
                let maxHeightFound = null;
                for (let index = 0; index < elementLength; index++) {
                    const element = elements[index];
                    // Calculate the height of the element
                    const elementHeight = element.offsetHeight;
                    if (maxHeightFound === null || elementHeight > maxHeightFound) {
                        maxHeightFound = elementHeight;
                    }
                }
                if (maxHeightFound === null) {
                    return;
                }
                for (let index = 0; index < elementLength; index++) {
                    const element = elements[index];
                    element.style.height = maxHeightFound + 'px';
                }
            }, 30);
        },
        matchBoxHeights() {
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-h2");
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-h3");
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-item--1");
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-item--2");
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-item--3");
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-item--4");
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-item--5");
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-item--6");
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-item--7");
        },
        matchFuelBoxHeights() {
            this.matchHeightForQuerySelector(".tco-tool__comparison-card-item--5");
        },
        handleIceVehicleSelected() {
            this.showIceSelector = false;
            this.showEvSelector = false;
            this.showBrandSelector = false;
            if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                const target = this.$refs['comparison'];
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        },
    },
    computed: {
        ...mapState([
            'brands',
            'selectedEvModel',
            'selectedIceModel',
            'selectedEvVehicle',
            'selectedIceVehicle',
        ]),
        brandCount() {
            return this.brands.length;
        },
        formBrandID() {
            return this.formIdentifier + '-' + this._uid;
        },
        formattedDeposit() {
            return '£' + NumberFormat(this.deposit, 0);
        },
        formattedMileage() {
            return NumberFormat(this.mileage, 0);
        },
        selectedEvVehicleTitle() {
            if (!this.selectedEvModel.electric_model_title) {
                return this.selectedEvModel.short_name;
            }

            return this.selectedEvModel.electric_model_title;
        },
        bothVehiclesSelected() {
            if (!this.selectedEvVehicle) {
                return false;
            }
            if (!this.selectedIceVehicle) {
                return false;
            }
            return [
                this.selectedEvVehicle.id,
                this.selectedIceVehicle
            ];
        }
    },
    created() {
        this.getBrands();
        if (window.matchMedia("only screen and (min-width: 768px)").matches) {
            this.showBrandSelector = true;
        }
    },
    mounted() {
        // this.setupSliders();
        // Call this.matchBoxHeights() when the window is resized or the orientation changes
        window.addEventListener('resize', this.matchBoxHeights);
        window.addEventListener('orientationchange', this.matchBoxHeights);
    }
}
</script>

<style lang="scss">
@import "../../../../sass/redesign/variables";
@import "../../../../sass/redesign/nouislider/nouislider-redesign";

.tco-tool {
    &__container {
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-top: 15px;
        margin-bottom: 15px;
    }

    &__comparison {
        display: grid;
        column-gap: 15px;
        grid-template-columns: repeat(2, minmax(0, 1fr));

        @media (max-width: 767px) {
            column-gap: 0;
            margin-left: -15px;
            margin-right: -15px;
        }
    }

    &__filters {
        padding: 25px;
        background-color: #dcf0eb;
        border-radius: $default-card-border-radius;
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        column-gap: 20px;
        row-gap: 40px;

        @media (min-width: 768px) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        @media (min-width: 992px) {
            grid-column: 1/3;
            grid-template-columns: repeat(12, minmax(0, 1fr));
        }
    }

    &__drop-down {
        @media (min-width: 768px) {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: stretch;
            grid-column: span 4;
        }
    }

    &__label {
        font-size: 16px;
        font-weight: 600;
        display: block;
        margin-bottom: 5px;
    }

    &__fake-select {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        background: white !important;
        border: none;
        border-radius: 6px;
        padding: 11px 13px !important;
        color: #0093D6;
        height: 45px;
        width: 100%;
        text-align: left;
        text-transform: none;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        box-shadow: none;

        @media (min-width: 768px) {
            max-width: 400px;
        }

        &--selected {
            &::after {
                position: absolute;
                content: ' ';
                background: rgba(0, 163, 224, 0.4);
                width: 100%;
                height: 100%;
                border-radius: 6px;
                border: 1px solid #00A3E0;
                margin-left: -13px;
            }
        }

        &--disabled {
            cursor: not-allowed;
            background: #eaeaea !important;
            color: #808080;
        }
    }

    &__slider {
        padding-right: 30px;

        @media (min-width: 992px) {
            grid-row: 2/3;
            grid-column: span 4;

            &--term {
                grid-column: 1/5;
            }
            &--deposit {
                grid-column: 5/9;
            }
            &--mileage {
                grid-column: 9/13;
            }
        }
    }

    &__slider-container {
        .noUi-connect {
            background: #62CAAF;
        }
        .noUi-horizontal {
            height: 10px;
            cursor: pointer;
            margin-bottom: 10px;
            background: #FFFFFF;
        }
        .noUi-horizontal .noUi-handle {
            width: initial;
            height: initial;
            padding: 10px;
            right: -22px;
            top: -17px;
            cursor: ew-resize;
            z-index: 2;
        }
        .noUi-handle {
            border: 0;
            border-radius: 0;
            background: transparent;
            box-shadow: none;
        }
        .noUi-handle::before,
        .noUi-handle::after {
            content: none;
            display: none;
        }
        .noUi-touch-area {
            border-color: #FFFFFF;
            background: #0B1E3A;
            width: 24px;
            height: 24px;
            border-radius: 23px;
        }
        .noUi-pips-horizontal {
            padding-top: 5px;
        }
        .noUi-value {
            color: #f7f7f7;
            top: 10px;
        }
        .noUi-marker {
            position: absolute;
            background: #f7f7f7;
        }
        .noUi-marker-large {
            background: #f7f7f7;
        }
        .noUi-marker-horizontal.noUi-marker {
            margin-left: -1px;
            width: 2px;
            height: 5px;
        }
        .noUi-marker-horizontal.noUi-marker-normal {
            display: none;
        }
        .noUi-marker-horizontal.noUi-marker-large {
            height: 12px;
        }

        &--green {
            .noUi-connect {
                background: #00FFBD;
            }
        }
    }

    &__slider-label-container {
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        align-items: flex-start;
        gap: 5px;
        margin-bottom: 15px;

        @media screen and (min-width: 768px) {
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
        }
    }

    &__slider-label {
        font-size: 16px;
        color: #031332;
    }

    &__slider-value {
        font-size: 16px;
        font-weight: 600;
        color: #0093D6;

        &--white {
            color: white;
        }
    }

    &__btn-calculate {
        @media (min-width: 768px) {
            grid-column: 1/3;
            grid-row: 3/4;
        }
    }

    &__btn-reset {
        background: none;
        @media (min-width: 768px) {
            grid-column: 3/5;
            grid-row: 3/4;
        }
    }

    &__popout {
        padding: 30px 30px;

        @media (max-width: 767px) {
            position: fixed;
            z-index: 2000;
            inset: 0px;
            background: white;
            max-width: 100vw;

            &--scrollable {
                overflow-y: scroll;
            }
        }

        @media (min-width: 768px) {
            padding: 30px 40px;
            grid-column: 1/13;
            grid-row: 2/4;
            z-index: 100;
        }
    }

    &__popout-top {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
    }

    &__popout-title {
        flex-grow: 1;
        text-align: center;
        color: #243782;
    }

    &__popout-label {
        font-size: 16px;
        font-weight: 600;
        color: #0093D6;
        display: block;
        margin-bottom: 12px;
    }

    &__popout-grid {
        display: grid;
        grid-template-rows: auto minmax(0, 1fr) 45px;

        @media (max-width: 768px) {
            gap: 30px;
            height: 100%;
        }
        @media (min-width: 768px) {
            grid-template-columns: minmax(0, 2fr) 2px minmax(0, 1fr);
            grid-template-rows: minmax(0, 1fr) auto;
            column-gap: 40px;
        }
    }

    &__popout-grid-controls {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        @media (min-width: 768px) {
            display: none;
            margin-bottom: 0;
        }
    }

    &__popout-grid-back {
    }

    &__popout-grid-title {
        color: #17355F;
        font-size: 18px;
        font-weight: 700;
        text-align: center;
    }

    &__popout-grid-models-container {
        height: 100%;
    }

    &__popout-grid-models {
        @media (max-width: 767px) {
            display: none;
        }

        @media (min-width: 768px) {
            grid-column: 1/2;
            grid-row: 1/3;
        }

        &--open {
            @media (max-width: 767px) {
                display: block;
                grid-row: 2/4;
            }
        }
    }

    &__popout-grid-separator {
        grid-column: 2/3;
        grid-row: 1/3;
        background: #979797;
        height: 100%;

        @media (max-width: 767px) {
            display: none;
        }
    }

    &__popout-grid-model-list {
        display: grid;
        gap: 15px;
        grid-template-columns: repeat(2, minmax(0, 1fr));

        @media (min-width: 768px) {
            grid-template-columns: repeat(4, minmax(0, 1fr));
        }
    }

    &__popout-grid-model {
        border: 1px solid transparent;
        border-radius: 6px;
        cursor: pointer;
        box-shadow: 0 0 5px 0 rgba(0,147,214,0), inset 0 0 5px 0 rgba(0,147,214,0);
        transition: border 150ms ease-in-out, box-shadow 150ms ease-in-out;
        padding: 10px;

        @media (min-width: 768px) {
            padding: 14px;
        }

        &:hover,
        &--selected {
            border-color: #0093D6;
            box-shadow: 0 0 5px 0 rgba(0,147,214,1), inset 0 0 5px 0 rgba(0,147,214,1);
        }
    }

    &__popout-grid-model-title {
        font-size: 14px;
        font-weight: 600;
        color: #0B1E3A;
    }

    &__popout-grid-model-price {
        font-size: 13px;
        font-weight: 400;
        color: #0B1E3A;

        span {
            font-size: 16px;
            font-weight: 600;
            color: #EF7D00;
        }
    }

    &__popout-grid-right {
        @media (max-width: 767px) {
            display: none;
        }

        @media (min-width: 768px) {
            grid-column: 3/4;
            grid-row: 1/2;
        }

        &--open {
            @media (max-width: 767px) {
                display: block;
                grid-row: 2/3;
            }
        }
    }

    &__popout-grid-trim-list {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 15px;
    }

    &__popout-grid-actions {
        @media (max-width: 767px) {
            display: none;
        }

        @media (min-width: 768px) {
            grid-column: 3/4;
            grid-row: 2/3;
        }

        &--open {
            @media (max-width: 767px) {
                display: block;
                grid-row: 3/4;
            }
        }
    }

    &__brand-logo-border {
        margin-top: 0;
        margin-left: auto;
        margin-right: auto;
    }

    &__choose-brand-box {
        margin-top: 15px;
    }

    &__brand-logo-outer {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        justify-content: space-evenly;
        will-change: background-color;
        // border-radius: 6px;
        // padding-bottom: 15px;
        // border: 1px solid transparent;
        cursor: pointer;

        &--selected,
        &:hover {
            background-color: rgba(0,163,224,0.4);
            // border: 1px solid #00A3E0;
            // &::after {
            //     position: absolute;
            //     content: '';
            //     width: calc(100% - 20px);
            //     bottom: -15px;
            //     height: 6px;
            //     background: #0093D6;
            // }
        }
    }

    &__brand-logo {
        flex-grow: 1;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        }

    &__choose-brand-btn {
        justify-self: flex-end;
    }

    &__popout-grid-trims {
        margin-bottom: 22px;
    }

    &__select-model-outer {
        position: relative;
        margin-bottom: 32px;
        padding: 0;
    }

    &__select-model-title {
        display: block;
        font-size: 13px;
        color: #4A4A4A;
        font-weight: 600;
        padding-bottom: 2px;
    }

    &__select-model-label {
        height: auto;
        white-space: wrap;
        text-align: left;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        font-weight: 600;
        text-transform: initial;
        color: $primary;
        padding: 11px 15px 14px 15px;
        transition-property: color, background-color;

        &:hover {
            color: #FFF;
        }
    }

    &__select-model-arrow {
        transform: rotate(0deg);
        transition: 300ms transform ease-in-out;
        &--selected {
            transform: rotate(180deg);
        }
    }

    &__select-model-container {
        position: absolute;
        bottom: -5px;
        transform: translateY(100%);
        background: #fff;
        border: 1px solid #0093D6;
        border-radius: 10px;
        font-weight: 400;
        font-size: 16px;
        left: 0;
        right: 0;
        padding: 9px 9px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        align-items: stretch;
        z-index: 10;
    }

    &__select-model-btn {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: flex-start;
        background: none;
        border: none;
        outline: none;
        box-shadow: none;
        cursor: pointer;
        text-align: left;
        padding: 11px 11px;
        transition-property: color, background-color;
        border-radius: 10px;
        color: #0093D6;

        &--electric {
            color: #62CAAF;
        }

        &--selected {
            background-color: #0093D6;
            color: #FFF;
            cursor: initial;
        }

        &:hover {
            background-color: #0093D6;
            color: #FFF;
        }
    }

    &__comparison-cards {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 15px;
    }

    &__comparison-card-img-container {
        @media (max-width: 768px) {
            position: absolute;
            top: 0;
            transform: translateY(-50%);
        }

        @media (min-width: 768px) {
            position: relative;
            margin-bottom: -120px;
            padding: 0 70px;
        }
    }

    &__comparison-card-img {
        z-index: 1;
        position: relative;
    }


    &__swiper-container {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 20px;
    }
    &__swiper {
        flex-basis: calc(100% - 75px);

        @media screen and (min-width: 768px) {
            flex-basis: calc(100% - 118px);
        }
    }

    &__swiper-btn {
        flex-basis: 32px;
        height: 32px;
        flex-grow: 0;
        flex-shrink: 0;
        cursor: pointer;
        transform: scale(1.0);
        transition: 150ms transform ease-in-out, 150ms opacity ease-in-out;
        @media screen and (min-width: 768px) {
            flex-basis: 49px;
            height: 49px;
        }
        &--disabled {
            opacity: 0.2;
            cursor: initial;
        }
        &.swiper-button-lock {
            display: block;
        }
        &.swiper-button-disabled {
            // display: none;
            opacity: 0.35;
            cursor: auto;
            pointer-events: none;
        }
    }

    &__swiper-prev {
        background-image: url(/images/new/details/left-arrow.svg);
        background-size: cover;
        &:hover {
            transform: scale(1.05);
        }
    }

    &__swiper-next {
        background-image: url(/images/new/details/right-arrow.svg);
        background-size: cover;

        &:hover {
            transform: scale(1.05);
        }
    }

    &__paint-btn {
        flex-grow: 0;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        border: 1px solid #0C93FF;
        border-radius: 32px;
        background-color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: 150ms box-shadow ease-in;
        box-shadow: 0 0 0 0 #0C93FF, inset 0 0 0 0 #0C93FF;

        @media screen and (min-width: 768px) {
            width: 45px;
            height: 45px;
            border-radius: 45px;
        }

        &:hover {
            box-shadow: 0 0 3px 0 #0C93FF, inset 0 0 3px 0 #0C93FF;
        }

        &--active {
            box-shadow: 0 0 5px 0 #0C93FF, inset 0 0 5px 0 #0C93FF;
        }
    }
    &__paint-btn-inner {
        flex-grow: 0;
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        border-radius: 16px;
        background-color: #DFDFDF;

        @media screen and (min-width: 768px) {
            width: 25px;
            height: 25px;
            border-radius: 25px;
        }
    }

    &__comparison-card {
        box-shadow: $default-card-box-shadow-darker;
        padding-top: 100px;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 5px;

        @media (max-width: 767px) {
            padding-top: 60px;
            border-radius: 0;
            padding-left: 8px;
            padding-right: 8px;
        }
    }

    &__comparison-card-item {
        display: flex;
        flex-direction: column;
        gap: 5px;
        border-radius: 6px;
        background-color: #e5f4fa;
        font-size: 16px;
        font-weight: 400;
        color: #0B1E3A;
        padding: 10px 8px;

        &--finance {
            position: relative;
        }

        @media (min-width: 1120px) {
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            padding-left: 20px;
            padding-right: 30px;
            min-height: 55px;
            gap: 15px;

            &--5 {
                flex-direction: column;
                justify-content: center;
                align-items: stretch;
                gap: 0;
            }

            &--finance {
                height: 100px;
                display: block;
            }
        }

        &--hidden {
            visibility: hidden;
        }
    }

    &__comparison-card-item-triple {
        display: flex;
        flex-direction: column;
        gap: 5px;
        border-radius: 6px;
        font-size: 16px;
        font-weight: 400;
        color: #0B1E3A;
        padding: 0;

        @media (min-width: 1120px) {
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            padding-left: 0;
            padding-right: 0;
            gap: 15px;
        }
    }

    &__comparison-card-finance-values {
        display: flex;
        flex-direction: column;

        @media (min-width: 768px) {
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
        }
    }

    &__comparison-card-apr {
        padding-top: 10px;
        strong {
            font-size: 20px;
            font-weight: 600;
        }
    }
    &__comparison-card-quote {
        font-weight: 400;
        text-decoration: underline;
        height:auto !important;
    }

    &__finance-loading {
        position: absolute;
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 50px;
    }

    &__comparison-card-total {
        display: flex;
        flex-direction: column;
        font-size: 20px;
        font-weight: 600;
        color: #0B1E3A;
        padding-top: 10px 0;

        @media (min-width: 1120px) {
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            // padding-left: 20px;
            // padding-right: 30px;
            height: 55px;
        }

        &--hidden {
            visibility: hidden;
        }
    }

    &__comparison-card-link {
        font-size: 18px;
        font-weight: 500;
        color: #0093D6;
        flex-grow: 1;
        text-align: left;
        @media (min-width: 1120px) {
            text-align: center;
        }
    }

    &__comparison-card-link-icon {
        transition: 150ms transform ease-in-out;
        transform: rotate(0deg);
        &--open {
            transform: rotate(180deg);
        }
    }

    &__comparison-card-value {
        font-size: 20px;
        font-weight: 600;
        color: #0093D6;
    }

    &__comparison-card-slider {
        padding-top: 20px;
        grid-column: 1/4;
    }

    &__comparison-card-spacer {
        grid-column: 1/4;
    }

    &__comparison-card-total-value {
        font-size: 30px;
        font-weight: 600;
        color: #0093D6;
    }

    &__comparison-card-container {
        position: relative;

        @media (max-width: 767px) {
            margin-top: 90px;
        }

        &--electric {
            .tco-tool__comparison-card-h2,
            .tco-tool__comparison-card-h3,
            .tco-tool__comparison-card-apr,
            .tco-tool__comparison-card-quote {
                color: white;
            }

            .tco-tool__comparison-card {
                background-color: #62caaf;
            }

            .tco-tool__comparison-card-item {
                background-color: #76d1ba;
            }

            .tco-tool__comparison-card-total-value,
            .tco-tool__comparison-card-link,
            .tco-tool__comparison-card-value {
                color: white;
            }
            .tco-tool__info-icon {
                g {
                    fill: white;
                }
            }
        }
    }

    &__starburst {
        width: 12vw;
        max-width: 166px;
        position: absolute;
        z-index: 0;
        top: 0;
        right: 0;

        // @media (max-width: 380px) {
        //     top: -60px;
        // }

        // @media (max-width: 420px) {
        //     top: -70px;
        // }

        // @media (max-width: 767px) {
        //     top: -80px;
        // }
    }

    &__currency-input {
        margin-top: 0;
    }

    &__info-icon {
        height: 1em;
        width: 1em;
        cursor: pointer;
        user-select: none;
    }
}

.tco-finance-calculator {
    &__finance-card {
        margin-top: 10px;
    }

    &__quote-title {
        font-size: 22px;
        line-height: 22px;
        font-weight: 600;
        color: #183B77;
        padding-bottom: 12px;
    }

    &__card-item {
        display: flex;
        justify-content: space-between;
        padding-bottom: 12px;
    }

    &__card-item-label {
        font-size: 16px;
        color: #0b1e3a;
        font-weight: 400;
    }

    &__monthly-payment {
        color: #0093D6;
        font-weight: 600;
    }

    &__small-label {
        font-size: 13px;
        color: #183B77;
        font-weight: 100;
        @media (max-width: 767px) {
            display: block;
        }
    }

    &__card-item-value {
        font-size: 16px;
        font-weight: 600;
        color: #FF8500;
        text-align: right;
        padding-left: 10px;
    }
}

.tco-tool__container .choose-brand__grid {
    @media (max-width: 767px) {
        gap: 15px;
    }
}
</style>
